export default __webpack_public_path__ + "static/media/icon-magicWand.cf9ddd39.svg";